
import Vue from "vue";
import { Component } from "vue-property-decorator";
import publications, {
  Publication as PublicationType,
} from "@/store/publications";
import Publication from "@/components/Publication.vue";
import {titleToHash} from "@/utils/publications";

@Component({
  methods: {titleToHash},
  components: { Publication },
})
export default class Publications extends Vue {
  name = "Publications";
  emphasizedClass: Record<number, boolean> = {}

  mounted(): void {
    const hash = decodeURIComponent(location.hash.slice(1))
    if (!hash) return
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const pos = publications.map(v=>titleToHash(v.title!)).indexOf(hash);
    if (pos !== -1) {
      this.emphasizedClass = Object.assign({}, this.emphasizedClass, {[pos]: true});
      setTimeout(()=>{
        this.emphasizedClass[pos]=false
      }, 1000)
    }
    console.log("hash", location.hash, "强调了", pos !== -1 ? publications[pos].title : undefined)
  }

  get publications(): PublicationType[] {
    return publications;
  }
}
